// Maps UI document ids/types to backend document type codes

export type BackendDocumentType =
  | "IDENTITY_PROOF_CNI_FRONT"
  | "IDENTITY_PROOF_CNI_BACK"
  | "IDENTITY_PROOF_PASSPORT"
  | "ADDRESS_PROOF_RECENT_3_MONTHS"
  | "LEGAL_CONSENT"
  | "SIGNATURE_CARD"
  | "IDENTITY_PROOF_PORTRAIT"
  | "PEP_DECLARATION"
  | "OPENING_FORM_SIGNED"
  | "SAVINGS_OBJECTIVE_ATTESTATION";

export const mapDocumentIdToBackendType = (
  documentId: string
): BackendDocumentType | string | undefined => {
  switch (documentId) {
    case "cni-recto":
      return "IDENTITY_PROOF_CNI_FRONT";
    case "cni-verso":
      return "IDENTITY_PROOF_CNI_BACK";
    case "passport":
      return "IDENTITY_PROOF_PASSPORT";
    case "domicile":
      return "ADDRESS_PROOF_RECENT_3_MONTHS";
    case "consent":
      return "LEGAL_CONSENT";
    case "signature":
      return "SIGNATURE_CARD";
    case "portrait":
      return "IDENTITY_PROOF_PORTRAIT";
    case "id":
      return "IDENTITY_PROOF_CNI_FRONT"; // Additional document ID uses same type
    case "pep":
      return "PEP_DECLARATION";
    case "form":
      return "OPENING_FORM_SIGNED";
    case "epargne":
      return "SAVINGS_OBJECTIVE_ATTESTATION";
    default:
      return undefined;
  }
};

export const mapBackendTypeToUiIds = (
  backendType: BackendDocumentType
): string[] => {
  switch (backendType) {
    case "IDENTITY_PROOF_CNI_FRONT":
      return ["cni-recto", "id"];
    case "IDENTITY_PROOF_CNI_BACK":
      return ["cni-verso"];
    case "IDENTITY_PROOF_PASSPORT":
      return ["passport"];
    case "ADDRESS_PROOF_RECENT_3_MONTHS":
      return ["domicile"];
    case "LEGAL_CONSENT":
      return ["consent"];
    case "SIGNATURE_CARD":
      return ["signature"];
    case "IDENTITY_PROOF_PORTRAIT":
      return ["portrait"];
    case "PEP_DECLARATION":
      return ["pep"];
    case "OPENING_FORM_SIGNED":
      return ["form"];
    case "SAVINGS_OBJECTIVE_ATTESTATION":
      return ["epargne"];
  }
};
